import { Component, Inject, Prop, Vue } from 'vue-property-decorator'
import { Validator } from 'vee-validate'
import { ConfigurationImmediateShelfPriorityAssignmentResponse } from '@/modules/configurationModule/detail/automation/grossing-shelf/immediate-shelf-priority/services/configuration-immediate-shelf-priority-assignment/configuration-immediate-shelf-priority-assignment.dto'
import { ConfigurationPriorityResponse } from '@/modules/configurationModule/detail/automation/grossing-shelf/immediate-shelf-priority/services/configuration-priority/configuration-priority.dto'
import { configurationPriorityService } from '@/modules/configurationModule/detail/automation/grossing-shelf/immediate-shelf-priority/services/configuration-priority/configuration-priority.service'
import { CommonParams } from '@/api/resources/common/shared/models/common.models'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'

@Component
export default class ConfigurationAutomationGrossingShelfImmediateShelfPriorityModalBasicForm extends Vue {
    @Prop(String) readonly actionTitle!: string
    @Prop() readonly immediateShelfPriorityAssignment!: Partial<ConfigurationImmediateShelfPriorityAssignmentResponse>

    @Inject() externalValidator!: Validator

    get updateMode(): boolean {
        return !!this.immediateShelfPriorityAssignment?.id
    }

    async getPriorities(): Promise<ConfigurationPriorityResponse[]> {
        const params: CommonParams = {
            size: PAGINATOR_BIG_PAGE_SIZE
        }
        const response = await this.$_toCallUnique(configurationPriorityService.paginator(undefined, params))
        if (response) {
            return response.content
        }
        return []
    }

    constructor() {
        super()

        this.$validator = this.externalValidator
    }
}
